import { ApiClient } from "../api-client";
import { ApiClientError } from "../errors";
import schemaValidators from "./schema-validators";

export default class RosterClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClient["config"]) {
		super(config, schemaValidators);
	}

	getRoster = async ({
		page,
		size,
		locked,
		searchQuery,
		roles,
		sortBy,
		sortDirection,
	}: {
		page: number;
		size: number;
		locked?: boolean[];
		searchQuery?: string;
		roles?: string[];
		sortBy?: string[];
		sortDirection?: string[];
	}) => {
		try {
			const params = new URLSearchParams();
			params.set("page", String(page));
			params.set("size", String(size));
			if (locked && locked.length > 0) {
				params.set("locked", locked.map(String).join(","));
			}
			if (searchQuery && searchQuery !== "") {
				params.set("searchQuery", searchQuery);
			}
			if (roles && roles.length > 0) {
				params.set("roles", roles.join(","));
			}
			if (sortBy && sortBy.length > 0) {
				sortBy.forEach((value) => {
					params.append("sortBy", value);
				});
			}
			if (sortDirection && sortDirection.length > 0) {
				sortDirection.forEach((value) => {
					params.append("sortDirection", value);
				});
			}
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/roster?${params.toString()}`, {
				credentials: "include",
			});

			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.getRoster.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	getRosterStatistics = async () => {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/roster/stats`, {
				credentials: "include",
			});

			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.getRosterStatistics.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};

	updateRoster = async ({
		lti1p3AccountId,
		userId,
		role,
		locked,
	}: {
		lti1p3AccountId: string;
		userId: string;
		role: string;
		locked: boolean;
	}) => {
		try {
			const response = await super.fetch(`${this.config.verityOrigin}/api/verity/roster`, {
				method: "PUT",
				credentials: "include",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({ lti1p3AccountId, userId, role, locked }),
			});

			if (response.ok) {
				const obj: unknown = await response.json();
				if (this.schemaValidators.updateRoster.validate(obj)) {
					return obj;
				}
			}
		} catch (error) {
			if (error instanceof Error) {
				throw new ApiClientError(error);
			}
		}
		throw new ApiClientError();
	};
}
